import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';

import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import * as _ from 'lodash';

import { BaseServices } from './../../kuba.services';
import { Department, VehicleList } from './../models/vehicle';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class VehicleServices {
  constructor(private http: HttpClient) {}

  getAllVehicles() {
    return this.http
      .get(
        environment.BASE_URL + '/vehicle/vehicles/' + BaseServices.BusinessId
      )
      .map((result: any) => result);
  }

  getVehiclesById(id: number) {
    return this.http
      .get(environment.BASE_URL + '/vehicle/vehicle/' + id)
      .map((result: any) => result);
  }

  createVehicle(vehicle: VehicleList) {
    return this.http
      .post(environment.BASE_URL + '/vehicle/vehicle', vehicle)
      .map(result => result);
  }

  updateVehicle(vehicle: VehicleList) {
    return this.http
      .put(environment.BASE_URL + '/vehicle/vehicle', vehicle)
      .map(result => result);
  }

  deleteVehicle(id: number) {
    return this.http
      .delete(environment.BASE_URL + '/vehicle/vehicle/' + id)
      .map((response: any) => {
        return response;
      });
  }

  // update department in view
  updateDept(existingCategory: Department) {
    return this.http
      .put(
        environment.BASE_URL + '/department/' + existingCategory.Id,
        existingCategory
      )
      .map(result => result);
  }

  // adding new department in view
  createDept(newCategory: Department) {
    return this.http
      .post(environment.BASE_URL + '/department/', JSON.stringify(newCategory))
      .map(result => result);
  }

  deleteDepartment(id: number) {
    return this.http
      .delete(environment.BASE_URL + '/departmentdelete/' + id)
      .map(result => result);
  }

  getVehicleFeatures(businessId: number) {
    let featureId: number;
    let workingModule = JSON.parse(sessionStorage.getItem('workingModule'));
    featureId = workingModule.id;
    return this.http
      .get(environment.BASE_URL + '/business/' + businessId)
      .map((result: any) => {
        let feature = result.Features;
        let vehicleAdditionalFeature = _.find(JSON.parse(feature), {
          id: featureId,
          access: true
        });
        return vehicleAdditionalFeature;
      });
  }

  getUserVehicles(Id: number) {
    return this.http
      .get(environment.BASE_URL + '/vehicle/getuserVehicles/' + Id)
      .map((result: any) => result);
  }
}
